/**
 * Why a person set an action aside (MYAC-1639) — CMS's `ReviewRejectionReason`.
 *
 * A closed vocabulary on the way in: the commands refuse anything else, and
 * `other` says nothing by itself, so it is the one reason that needs the
 * comment. On the way out (the task, the view row) it stays a plain string: a
 * reason this build predates must still load, and then shows no label rather
 * than a raw key.
 */
export const REJECTION_REASONS = ['covered', 'not_applicable', 'duplicate', 'other'] as const

export type RejectionReason = (typeof REJECTION_REASONS)[number]

export function isRejectionReason(value: unknown): value is RejectionReason {
  return typeof value === 'string' && (REJECTION_REASONS as readonly string[]).includes(value)
}

/** The i18n key of a stored reason's label, or `null` for none or one this build cannot name. */
export function rejectionReasonKey(value: unknown): string | null {
  return isRejectionReason(value) ? `tasks.reject_dialog.reasons.${value}` : null
}

/** Whether a set-aside with this reason and comment can be sent: `other` needs the words. */
export function rejectionReady(reason: RejectionReason | '' | null, comment: string): boolean {
  if (!reason) return false
  return reason !== 'other' || comment.trim().length > 0
}
